import { SupportedNgo } from "./store.model";

export class Customization {
    public storeId: string
    public storeName: string
    public storeSeoName: string
    public causeIcons: CustomizationCauseIcons
    public abTests: Array<CustomizationAbTest>
}

export class CustomizationAbTest {
    public abTestId: string
    public seoName: string
    public name: string
    public pageType: string
    public mainColor: string
    public title: string
    public text: string
}

export class CustomizationCauseIcons {
    public icons: Array<CauseIcon>
    public ngos: Array<SupportedNgo>
}

export class CauseIcon {
    public id: string
    public ngoUrl: string
    public name: string
    public logo: string
    public default: boolean
}